import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "font-semibold mt-6" }

import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
  } from '@/components/ui/table'
  import { Roof } from "@/models/tables/roof.interface"
  import {Image, ImagePlus, MoreHorizontal, Pencil, Trash2, LineChart, FilePlus, File} from "lucide-vue-next";
  import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuTrigger
  } from "@/components/ui/dropdown-menu";
  import {Button} from "@/components/ui/button";
  import {ref, watch} from "vue";
  import useEventsBus from "@/utils/eventBus";
  import DeleteDialog from "@/components/tables/DeleteDialog.vue";
  import router from "@/router";
  import UploadDocumentDialog from "@/components/building/UploadDocumentDialog.vue";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'RoofsTable',
  props: {
    roofs: {},
    entity: {}
  },
  setup(__props: any) {

  const props = __props
  const isDeleteDialogOpen = ref(false);
  const isDocumentDialogOpen = ref(false);

  const { bus } = useEventsBus();

  const setIsDeleteDialogOpen = (value: boolean) => {
    isDeleteDialogOpen.value = value;
  };

  const setIsDocumentDialogOpen = (value: boolean) => {
    isDocumentDialogOpen.value = value;
  };

  watch(() => bus.value.get('update_'+props.entity), async () => {
    setIsDeleteDialogOpen(false);
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h3", _hoisted_1, _toDisplayString(_ctx.$t('building.roofs_list')), 1),
    _createVNode(_unref(Table), null, {
      default: _withCtx(() => [
        _createVNode(_unref(TableHeader), { class: "bg-gray-300 font-black" }, {
          default: _withCtx(() => [
            _createVNode(_unref(TableRow), null, {
              default: _withCtx(() => [
                _createVNode(_unref(TableHead), null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('column.name')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(TableHead), null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('column.code')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(TableHead), { class: "text-right" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('table.actions')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_unref(TableBody), null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.roofs, (roof) => {
              return (_openBlock(), _createBlock(_unref(TableRow), {
                key: roof.code
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(TableCell), null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(roof.name), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_unref(TableCell), null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(roof.code), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_unref(TableCell), { class: "grid justify-end" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(DropdownMenu), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(DropdownMenuTrigger), { "as-child": "" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(Button), {
                                variant: "ghost",
                                class: "w-8 h-8 p-0"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(MoreHorizontal), { class: "w-4 h-4" })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(DropdownMenuContent), { align: "end" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(DropdownMenuLabel), null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('table.actions')), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_unref(DropdownMenuItem), {
                                onClick: _withModifiers(($event: any) => (_ctx.$emit('edit', roof)), ["prevent"]),
                                class: "cursor-pointer"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(Pencil), { class: "mr-2 h-4 w-4" }),
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t('table.edit')), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick"]),
                              _createVNode(_unref(DropdownMenuItem), {
                                onClick: _withModifiers(($event: any) => (_unref(router).push({ name: 'camera', params: { id: roof.id, entity: 'coverages' }})), ["prevent"]),
                                class: "cursor-pointer"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(ImagePlus), { class: "mr-2 h-4 w-4" }),
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t('building.add_photo')), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick"]),
                              _createVNode(_unref(DropdownMenuItem), {
                                onClick: _withModifiers(($event: any) => (_unref(router).push({ name: 'photoRoof', params: { entity:'coverages', id: roof.id } })), ["prevent"]),
                                class: "cursor-pointer"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(Image), { class: "mr-2 h-4 w-4" }),
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t('building.gallery')), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick"]),
                              _createVNode(_unref(DropdownMenuItem), {
                                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (setIsDocumentDialogOpen(true)), ["prevent"])),
                                disabled: !roof.id,
                                class: "cursor-pointer"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(FilePlus), { class: "mr-2 h-4 w-4" }),
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t('building.add_document')), 1)
                                ]),
                                _: 2
                              }, 1032, ["disabled"]),
                              _createVNode(_unref(DropdownMenuItem), {
                                onClick: _withModifiers(($event: any) => (_unref(router).push({ name: 'documentsView', params: { entity:'coverages', id: roof.id } })), ["prevent"]),
                                disabled: !roof.id,
                                class: "cursor-pointer"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(File), { class: "mr-2 h-4 w-4" }),
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t('building.document_gallery')), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick", "disabled"]),
                              _createVNode(_unref(DropdownMenuItem), {
                                onClick: _withModifiers(($event: any) => (_unref(router).push({ name: 'rci', params: { id: roof.id }})), ["prevent"]),
                                class: "cursor-pointer"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(LineChart), { class: "mr-2 h-4 w-4" }),
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t('table.rci')), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick"]),
                              _createVNode(_unref(DropdownMenuItem), {
                                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (setIsDeleteDialogOpen(true)), ["prevent"])),
                                class: "cursor-pointer"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(Trash2), { class: "mr-2 h-4 w-4" }),
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t('table.delete')), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(DeleteDialog, {
                            entity: props.entity,
                            object: roof,
                            open: isDeleteDialogOpen.value,
                            "set-open": setIsDeleteDialogOpen
                          }, null, 8, ["entity", "object", "open"]),
                          _createVNode(UploadDocumentDialog, {
                            entity: props.entity,
                            "entity-id": roof.id,
                            open: isDocumentDialogOpen.value,
                            "set-open": setIsDocumentDialogOpen,
                            onEdit: _cache[2] || (_cache[2] = ($event: any) => (setIsDocumentDialogOpen(false)))
                          }, null, 8, ["entity", "entity-id", "open"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})